import React from 'react';
import TFFButton from '../../styled-components/TFFButton';
import { useIntl } from 'react-intl';

type CustomToolbarProps = {
  selectedRow: number;
  handleSetInProgress: (selectedRow: number) => void;
  handleRemoveFromAmendFailure: (selectedRow: number) => void;
};

const ActionsToolbar: React.FC<CustomToolbarProps> = ({
  selectedRow,
  handleSetInProgress,
  handleRemoveFromAmendFailure,
}) => {
  const intl = useIntl();

  return (
    <div className="tff-amend-failure-toolbar">
      <TFFButton
        buttonText={intl.formatMessage({ id: 'pages.involuntary-changes.set-in-progress' })}
        variant="secondary"
        handleClick={() => handleSetInProgress(selectedRow)}
      />
      <TFFButton buttonText="Close" handleClick={() => handleRemoveFromAmendFailure(selectedRow)} variant="secondary" />
    </div>
  );
};

export default ActionsToolbar;
